import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks/redux-hooks";
import { ApplicationState } from "../redux/reducers";
import SessionService from "../services/session-service";
import { UserRoles } from "../types/user-roles";
import AccessDenied from "../views/common-views/access-denied/access-denied";
import { url } from "../utils/url";

const PrivateRoute = ({
  children,
  roles,
}: {
  children: JSX.Element;
  roles: Array<UserRoles>;
}) => {
  let location = useLocation();
  const role = useAppSelector(
    (state: ApplicationState) => state.auth.typ_uzytkownika
  );
  const user = SessionService.getUser();
  const userHasRequiredRole =
    user && roles.includes(user.typ_uzytkownika) ? true : false;

  const isAuthenticated =
    user && user.token_dostepu !== null ? true : false;

  if (!isAuthenticated) {
    return <Navigate to={url.login} state={{ from: location }} />;
  }

  if (isAuthenticated && !userHasRequiredRole) {
    return <AccessDenied />;
  }
  return children;
};

export default PrivateRoute;
